// source: galaxycompletepb/apipb/domainpb/galaxymigratelink.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_duration_pb = require('google-protobuf/google/protobuf/duration_pb.js');
goog.object.extend(proto, google_protobuf_duration_pb);
var galaxycompletepb_apipb_domainpb_deployment_pb = require('../../../galaxycompletepb/apipb/domainpb/deployment_pb.js');
goog.object.extend(proto, galaxycompletepb_apipb_domainpb_deployment_pb);
goog.exportSymbol('proto.galaxycomplete.domain.GMLinkInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.galaxycomplete.domain.GMLinkInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.galaxycomplete.domain.GMLinkInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.galaxycomplete.domain.GMLinkInfo.displayName = 'proto.galaxycomplete.domain.GMLinkInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.galaxycomplete.domain.GMLinkInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.galaxycomplete.domain.GMLinkInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.GMLinkInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    linkid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    server: (f = msg.getServer()) && galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.toObject(includeInstance, f),
    client: (f = msg.getClient()) && galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.toObject(includeInstance, f),
    lastserveraddress: jspb.Message.getFieldWithDefault(msg, 6, ""),
    allowproxy: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    description: jspb.Message.getFieldWithDefault(msg, 20, ""),
    connected: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    numberOfConnections: jspb.Message.getFieldWithDefault(msg, 22, 0),
    latency: (f = msg.getLatency()) && google_protobuf_duration_pb.Duration.toObject(includeInstance, f),
    lastConnectionErrorMsg: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.galaxycomplete.domain.GMLinkInfo}
 */
proto.galaxycomplete.domain.GMLinkInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.galaxycomplete.domain.GMLinkInfo;
  return proto.galaxycomplete.domain.GMLinkInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.galaxycomplete.domain.GMLinkInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.galaxycomplete.domain.GMLinkInfo}
 */
proto.galaxycomplete.domain.GMLinkInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLinkid(value);
      break;
    case 2:
      var value = new galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.deserializeBinaryFromReader);
      msg.setServer(value);
      break;
    case 5:
      var value = new galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo;
      reader.readMessage(value,galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastserveraddress(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowproxy(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConnected(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setNumberOfConnections(value);
      break;
    case 23:
      var value = new google_protobuf_duration_pb.Duration;
      reader.readMessage(value,google_protobuf_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setLatency(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastConnectionErrorMsg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.galaxycomplete.domain.GMLinkInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.galaxycomplete.domain.GMLinkInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.galaxycomplete.domain.GMLinkInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getServer();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo.serializeBinaryToWriter
    );
  }
  f = message.getLastserveraddress();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAllowproxy();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getConnected();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getNumberOfConnections();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getLatency();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getLastConnectionErrorMsg();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string linkID = 1;
 * @return {string}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getLinkid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setLinkid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DeploymentIdentityInfo server = 2;
 * @return {?proto.galaxycomplete.domain.DeploymentIdentityInfo}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getServer = function() {
  return /** @type{?proto.galaxycomplete.domain.DeploymentIdentityInfo} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo, 2));
};


/**
 * @param {?proto.galaxycomplete.domain.DeploymentIdentityInfo|undefined} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
*/
proto.galaxycomplete.domain.GMLinkInfo.prototype.setServer = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.clearServer = function() {
  return this.setServer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.hasServer = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DeploymentIdentityInfo client = 5;
 * @return {?proto.galaxycomplete.domain.DeploymentIdentityInfo}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getClient = function() {
  return /** @type{?proto.galaxycomplete.domain.DeploymentIdentityInfo} */ (
    jspb.Message.getWrapperField(this, galaxycompletepb_apipb_domainpb_deployment_pb.DeploymentIdentityInfo, 5));
};


/**
 * @param {?proto.galaxycomplete.domain.DeploymentIdentityInfo|undefined} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
*/
proto.galaxycomplete.domain.GMLinkInfo.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.hasClient = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string lastServerAddress = 6;
 * @return {string}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getLastserveraddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setLastserveraddress = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional bool allowProxy = 7;
 * @return {boolean}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getAllowproxy = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setAllowproxy = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string description = 20;
 * @return {string}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional bool connected = 21;
 * @return {boolean}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getConnected = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setConnected = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional uint32 number_of_connections = 22;
 * @return {number}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getNumberOfConnections = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setNumberOfConnections = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional google.protobuf.Duration latency = 23;
 * @return {?proto.google.protobuf.Duration}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getLatency = function() {
  return /** @type{?proto.google.protobuf.Duration} */ (
    jspb.Message.getWrapperField(this, google_protobuf_duration_pb.Duration, 23));
};


/**
 * @param {?proto.google.protobuf.Duration|undefined} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
*/
proto.galaxycomplete.domain.GMLinkInfo.prototype.setLatency = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.clearLatency = function() {
  return this.setLatency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.hasLatency = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional string last_connection_error_msg = 24;
 * @return {string}
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.getLastConnectionErrorMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.galaxycomplete.domain.GMLinkInfo} returns this
 */
proto.galaxycomplete.domain.GMLinkInfo.prototype.setLastConnectionErrorMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


goog.object.extend(exports, proto.galaxycomplete.domain);
